import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./it";
import { refreshCatalog } from "./catalogRefresh";

export const SUPPORTED_LANGS = ["it", "en", "ro", "de", "fr", "es", "pt", "nl", "pl", "el", "sv", "zh", "ru", "uk"];

// Solo l'italiano è nel bundle iniziale: le altre lingue si caricano on-demand (code-splitting)
const LOADERS = {
  en: () => import("./en"), ro: () => import("./ro"), de: () => import("./de"), fr: () => import("./fr"), es: () => import("./es"),
  pt: () => import("./pt"), nl: () => import("./nl"), pl: () => import("./pl"), el: () => import("./el"), sv: () => import("./sv"),
  zh: () => import("./zh"), ru: () => import("./ru"), uk: () => import("./uk"),
};

const LazyBackend = {
  type: "backend",
  init() {},
  read(lng, _ns, callback) {
    const load = LOADERS[lng];
    if (!load) return callback(null, {});
    load().then((m) => callback(null, refreshCatalog(m.default, lng))).catch((e) => callback(e, null));
  },
};

i18n
  .use(LanguageDetector)
  .use(LazyBackend)
  .use(initReactI18next)
  .init({
    resources: { it: { translation: refreshCatalog(it, "it") } },
    partialBundledLanguages: true,
    fallbackLng: "it",
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: { order: ["querystring", "localStorage", "navigator"], lookupQuerystring: "lang", caches: [] },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

i18n.on("languageChanged", (lng) => { document.documentElement.lang = lng.slice(0, 2); });
document.documentElement.lang = (i18n.language || "it").slice(0, 2);

// Scelta esplicita dell'utente (switcher): persiste; il rilevamento automatico dal browser non viene salvato
export const chooseLanguage = (code) => { localStorage.setItem("i18nextLng", code); i18n.changeLanguage(code); };

export default i18n;
